import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Heart, Users } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      className="sticky top-0 z-40 w-full bg-[#1A1A1A]/85 backdrop-blur-xl border-b border-[#D4AF37]/15"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="navbar-logo">
          <span className="font-display text-3xl font-normal tracking-tight text-[#F5F5F5] group-hover:text-[#D4AF37] transition-colors">
            Goji
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-[#F5F5F5]/70">
          <Link to="/" className="font-label text-[0.65rem] hover:text-[#D4AF37] transition-colors" data-testid="nav-home">Home</Link>
          <Link to="/pricing" className="font-label text-[0.65rem] hover:text-[#D4AF37] transition-colors" data-testid="nav-pricing">Memberships</Link>
          {user && (
            <>
              <Link to="/dashboard" className="font-label text-[0.65rem] hover:text-[#D4AF37] transition-colors flex items-center gap-1.5" data-testid="nav-dashboard">
                <Heart className="w-3.5 h-3.5" /> Discover
              </Link>
              <Link to="/matches" className="font-label text-[0.65rem] hover:text-[#D4AF37] transition-colors flex items-center gap-1.5" data-testid="nav-matches">
                <Users className="w-3.5 h-3.5" /> Connections
              </Link>
            </>
          )}
        </nav>

        <div className="flex items-center gap-4">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-3 px-4 py-2 border border-[#D4AF37]/25">
                {user.tier && (
                  <span className="font-label text-[0.6rem] text-[#D4AF37]" data-testid="navbar-tier">
                    {user.tier}
                  </span>
                )}
                <span className="text-sm text-[#F5F5F5]/85" data-testid="navbar-user-name">{user.name?.split(" ")[0]}</span>
              </div>
              <button onClick={onLogout} className="btn-ghost !py-2 !px-4 flex items-center gap-2" data-testid="navbar-logout-button">
                <LogOut className="w-3.5 h-3.5" /> Exit
              </button>
            </>
          ) : (
            <>
              <Link to="/auth" className="btn-ghost !py-2 !px-5" data-testid="navbar-login-link">
                Sign In
              </Link>
              <Link to="/auth?mode=signup" className="btn-ghost !py-2 !px-5" data-testid="navbar-signup-link">
                Apply
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
